import React, { useState, useEffect } from 'react';
import { Document, Page, Text, View, StyleSheet, pdf, Image } from '@react-pdf/renderer';
import asc from "@src/assets/tss/asc.jpeg";
import ico from "@src/assets/tss/ico.jpeg";
import sc from "@src/assets/tss/sc.jpg";
import sia from "@src/assets/tss/sia.png";
import dayjs from 'dayjs';
import { imageUrlToBase64 } from '../../util/base64';
import { getTimeOfDay } from '../../util/getTimeOfDay';
import tss from "@src/assets/tenantLogos/tss.png";
import intra from "@src/assets/tenantLogos/intra.png";
import prm from "@src/assets/tenantLogos/prm.png";

// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  header: {
    paddingBottom: 15,
    display:'flex',
    flexDirection:'row',
    alignItems: 'center',
    justifyContent:'space-between',
    borderBottom: 1,
  },
  headerTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  headerAddress: {
    fontSize: 9,
    color: '#333',
    lineHeight: 1.4,
  },
  infoSection: {
    borderWidth: 1,
    borderTop: 0,
    borderColor: '#000',
    marginBottom: 15,
  },
  infoRow: {
    display:'flex',
    flexDirection: 'row',
    justifyContent:'space-between',
    fontSize: 15,
  },
  infoLabel: {
    fontWeight: 'bold',
    marginTop:10,
  },
  quesborder:{
    borderLeft: 1,
    padding: 4,
    width: '36%'

  },
  quesPadding:{
    padding: 4,
    paddingLeft: 15,
    fontWeight: 600,
    width: '64%'
  },
  paddingWithBold:{
    paddingLeft: 15,
    fontWeight: 'bold'
  },
  padding:{
    paddingLeft: 15,
  },
  rows:{
    borderTop:1, display:'flex', flexDirection: 'row', justifyContent:'space-between'
  },
  footer: {
    marginTop: 10,
    display: 'flex',
    flexDirection:'row',
    gap: 10,
    alignItems: 'center'
  }

});



// Header Component
const TssHeader = () => (
  <View style={styles.header} fixed>
    <Text style={styles.headerTitle}>Daily Patrol Report</Text>
    <Image style={{width:'200px'}} src={tss} />
  </View>
);


const IntraHeader = () => (
  <View style={styles.header} fixed>
    <Text style={styles.headerTitle}>Daily Patrol Report</Text>
    <Image style={{width:'200px'}} src={intra} />
  </View>
);

const PRMHeader = () => (
  <View style={styles.header} fixed>
    <Text style={styles.headerTitle}>Daily Patrol Report</Text>
    <Image style={{width:'200px'}} src={prm} />
  </View>
);

// Footer Component
const Footer = () => (
  <View style={{display:'flex', justifyContent:'space-between', flexDirection:'row',}} fixed>
    
    <View style={styles.footer}>
        <Image style={{width:'50px', height: '30px'}} src={asc} />
        <Image style={{width:'30px', height:'30px'}} src={sia} />
        <Image style={{width:'30px', height:'30px'}} src={ico} />
        <Image style={{width:'30px', height:'30px'}} src={sc} />

        <View >
            <Text style={{fontWeight:'bold', marginBottom:4, fontSize: 7}}>Company Reg No: 08296059</Text>
            <Text style={{fontSize:7}}>VAT-153559495</Text>
            <Text style={{fontSize:7}}>T:  020 34899587 (24 Hour Control Room)</Text>
            <Text style={{fontSize:7}}>T2: 020 8004 6957 </Text>
            <Text style={{fontSize:7}}>T3: 0800 779 8083 </Text>
        </View>
    </View>

    <View style={{paddingTop:4}}>
        <Text style={{fontWeight:'bold', marginBottom:4, fontSize: 7}}>Tragopan Security Solutions LTD</Text>
        <Text style={{fontSize:7}}>Unit 10 Aerodrome Way, Heston</Text>
        <Text style={{fontSize:7}}>TW59QB, United Kingdom</Text>
        <Text style={{fontSize:7}}>E: control@tragopan-security.co.uk </Text>
        <Text style={{fontSize:7}}>E2: info@tragopan-security.co.uk </Text>
        <Text style={{fontSize:7}}>W: www.tragopan-security.co.uk </Text>
    </View>
    
  </View>
);

// Main Document Component
export const PatrolReportDocument = ({data}) => {

    
    if(!data) {
      console.log("No data provided");
      return null;
    }
    
    if(!data || data.length === 0) {
      console.log("No calls in data");
      return null;
    }


    const clockIn = data?.find((call)=>call?.callType=="Clock In"); 
    const clockout = data?.find((call)=>call?.callType=="Clock Out"); 

    const d = async(checkCallActivityImage)=>{
      const i = await imageUrlToBase64(checkCallActivityImage);
      console.log(i, "checkCallActivityImage")
    }
    
    useEffect(()=>{
      if(data[2]?.checkCallActivityImage){
        d(data[2]?.checkCallActivityImage);
      }
    },[data[2]?.checkCallActivityImage]);

    return(
      <Document>
        {/* Page 1 */}
        <Page size="A4" style={styles.page}>
          {
            // tss
            clockIn?.tenantId=="68c042ffcc67877900bf380f" ?
            <TssHeader />

            :
            clockIn?.tenantId=="68b055eae17a6ecb72d3a074" ?
            <IntraHeader />

            :

            clockIn?.tenantId=="68b055eae17a6ecb72d3a074" ?
            <PRMHeader/>
            :null


          }

          {/* Info Section */}
          <View style={styles.infoSection}>

            {/* site name and  */}
            <View style={styles.infoRow}>
                <View style={{width:'60%',padding:20}}>
                    <Text style={styles.infoLabel}>{clockIn?.siteDetail?.sitename}</Text>
                    <Text style={styles.infoLabel}>{clockIn?.siteDetail?.postcode}</Text>
                </View>
                <View style={[{width:'40%', textAlign:'center', padding:20, fontWeight: 'bold', fontSize: 15}, styles.quesborder]}>
                    <Text style={{paddingTop:20}}>
                        {dayjs(clockout?.requiredAt).format("Do MMM YYYY")}
                    </Text>
                </View>
            </View>

            {/* client box */}
            <View style={{display:'flex', flexDirection: 'row', borderTopWidth:1 }}>

                
                    <Text style={{padding:'15px', borderRight:1, fontWeight: 'bold'}}>
                        Client
                    </Text>
                    <Text style={{padding:'15px', borderRight:1, width:'40%'}}>
                      {clockIn?.customerDetail?.customername}
                    </Text>

                    <Text style={{padding:'15px', borderRight:1, fontWeight: 'bold'}}>
                        On-site
                    </Text>
                    <Text style={{padding:'15px', borderRight:1}}>
                        {dayjs(clockIn?.requiredAt).format("HH:mm")}
                    </Text>

                    <Text style={{padding:'15px', borderRight:1, fontWeight: 'bold'}}>
                        Off-site
                    </Text>
                    <Text style={{padding:'15px'}}>
                      {dayjs(clockout?.requiredAt).format("HH:mm")}
                    </Text>
                

            </View>

            {/* Ques intro */}
            {/* <View style={{display:'flex'}}>

                <View style={styles.rows}>
                    <Text style={styles.quesPadding}>Type of Event</Text>
                    <Text style={styles.quesborder}>Guarding</Text>
                </View>

                <View style={styles.rows}>
                    <Text style={styles.quesPadding}>Any incident recorded during the patrols </Text>
                    <Text style={styles.quesborder}>None</Text>
                </View>


                <View style={styles.rows}>
                    <Text style={styles.quesPadding}>Intrusion/Break-in </Text>
                    <Text style={styles.quesborder}>N/A</Text>
                </View>

                <View style={styles.rows}>
                    <Text style={styles.quesPadding}>Parties Contacted</Text>
                    <Text style={styles.quesborder}>N/A</Text>
                </View>

                <View style={styles.rows}>
                    <Text style={styles.quesPadding}>Police Information</Text>
                    <Text style={styles.quesborder}>N/A</Text>
                </View>

                <View style={styles.rows}>
                    <Text style={styles.quesPadding}>Crime Reference</Text>
                    <Text style={styles.quesborder}>N/A</Text>
                </View>

                <View style={styles.rows}>
                    <Text style={styles.quesPadding}>Police Collar Number</Text>
                    <Text style={styles.quesborder}>N/A</Text>
                </View>

            </View> */}

            <View style={{marginBottom:150}}>

                <View style={styles.rows}>
                    <Text style={[{fontSize:18, textDecoration:'underline', padding: 15, fontWeight:'bold' }]}>Patrol Details:</Text>
                </View>

                <Text style={styles.paddingWithBold}>{dayjs(clockIn?.requiredAt).format("HH:mm")}</Text>
                <Text style={[styles.padding, { marginTop: 5}]}>
                  {
                    clockIn?.checkCallActivityComment || "The officer reached the site and booked on with control. Officer has thoroughly visited & everything was fine on-site"
                  }
                    
                </Text>

                <View style={{borderTop: 3, borderColor:'lightgray', margin:'15 0'}}/>


                {
                  data?.filter((call)=>call.callType=="Check call")?.map((call, index)=>(
                        <View 
                            key={index}
                            wrap={false} 
                            // style={{borderTop:1}}
                        >
                            <Text style={[{marginTop:12, marginBottom: 5}, styles.paddingWithBold]}>{dayjs(call?.requiredAt).format("HH:mm")}</Text>
                            <Text style={styles.padding}>
                                {call?.checkCallActivityComment}
                            </Text>
                        </View>

                    ))
                }


                <Text style={[{marginTop:12, marginBottom: 5}, styles.paddingWithBold]}>{dayjs(clockout?.requiredAt).format("HH:mm")}</Text>
                <Text style={[styles.padding]}>
                  {
                    clockout?.checkCallActivityComment || "Officer conducted final external and internal patrol of the site. Officer makes sure that fire exit door is properly secured."
                  }
                </Text>


                <Text style={[styles.padding, { margin: 15, marginTop: 45, textAlign:'center', textDecoration:'underline', backgroundColor:'yellow', }]}>
                  The officer left the site after receiving acknowledgement from the control; shift has been handed over to {getTimeOfDay(dayjs(clockout?.requiredAt))} officer.
                </Text>



            </View>

          </View>

          <View style={{margin: 15}}>
            <Text style={[{fontSize:18, }]}>Pictures</Text>
              {
                data
                  ?.filter((call) => call.callType == "Check call" && call?.checkCallActivityImage)
                  ?.map((call) => (
                        <Image 

                          src={call?.checkCallActivityImage}
                          style={{marginTop: 10, marginBottom: 50, width:300,  objectFit:'contain'}}
                          
                          
                        />
                    )
                  )
              }
          </View>
        
          <View style={{borderTop: 1}} fixed/>
          {
            clockIn?.tenantId=="68c042ffcc67877900bf380f" &&
            <Footer  />
          }

        </Page>

      </Document>
    );

};

// ============================================
// SOLUTION FOR ANT DESIGN MODAL
// ============================================

// Component for use in Ant Design Modal
const PatrolReportViewer = ({data}) => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const generatePdf = async () => {
      try {
        setLoading(true);
        const blob = await pdf(<PatrolReportDocument data={data}/>).toBlob();
        const url = URL.createObjectURL(blob);
        setPdfUrl(url);
        setLoading(false);
      } catch (error) {
        console.error('Error generating PDF:', error);
        setLoading(false);
      }
    };

    generatePdf();

    // Cleanup
    return () => {
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl);
      }
    };
  }, []);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>Loading PDF...</div>
      </div>
    );
  }

  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <iframe
        src={pdfUrl}
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
        }}
        title="Patrol Report PDF"
      />
      {/* <DownloadPatrolReport /> */}
    </div>
  );
};

export default PatrolReportViewer;


// import { PDFDownloadLink } from '@react-pdf/renderer';
// import { Button } from 'antd';
// import { DownloadOutlined } from '@ant-design/icons';

// const DownloadPatrolReport = () => (

// );